import React from 'react';
import './index.scss';

type InfoProps = {
  title: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

const Info: React.FC<InfoProps> = ({ title, icon, onClick, children }) => (
  <div className="configuration_info">
    <p>{title}</p>
    {children ? (
      children
    ) : (
      <>
        {onClick && (
          <>
            {icon ? (
              <button type="button" onClick={onClick}>
                {icon}
              </button>
            ) : (
              <button className="configuration_info__icon" type="button" onClick={onClick}>
                ?
              </button>
            )}
          </>
        )}
      </>
    )}
  </div>
);

export default Info;
